import React from 'react';
import style from './style.module.scss';

const Menu = () => {
  return <div className={style.menu}>Menu</div>;
};

export default Menu;
